import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { Button } from '@gasbuddy/react-components';
import GridColumns from '../../grid-columns';
import FuelTypePropType from '../../../utils/prop-types/fuel-type';
import ToggleIcon from '../../toggle-icon';
import Modal from '../../modal';

const { sortByFuelTypes } = require('../../../../lib/bputils').default;

export default function FuelTypesEditModal({ buttonClassName, fuelTypes: fuelTypesProps, allFuelTypes, onSave }) {
  const [fuelTypes, setFuelTypes] = React.useState(fuelTypesProps);

  React.useEffect(() => {
    setFuelTypes(fuelTypesProps);
  }, [fuelTypesProps]);

  const handleOnFuelTypeClick = (e) => {
    e.preventDefault();
    const fuelTypeId = e.currentTarget.dataset?.value;
    const isChecked = e.currentTarget.getAttribute('aria-checked');
    let selectedFuelTypes = [];
    if (isChecked === 'true') {
      selectedFuelTypes = fuelTypes.filter(f => f.id !== fuelTypeId);
    } else {
      const newFuelType = allFuelTypes.find(f => f.id === fuelTypeId);
      selectedFuelTypes = [newFuelType].concat(fuelTypes);
    }

    setFuelTypes(selectedFuelTypes);
  };

  const handleOnModalClose = () => {
    setFuelTypes(fuelTypesProps);
  };

  const handleOnSave = () => {
    onSave(fuelTypes);
  };

  return (
    <Modal
      title="EDIT FUEL TYPES"
      size="md"
      saveButtonText="Save Changes"
      onSave={handleOnSave}
      onClose={handleOnModalClose}
      button={(
        <Button
          type="button"
          className={buttonClassName}
          link
        >
          <FontAwesomeIcon icon={faPen} />
        </Button>
      )}
    >
      <GridColumns contents={
      sortByFuelTypes(allFuelTypes).map(fueltype => ({
        key: fueltype.id,
        body: (
          <ToggleIcon
            key={fueltype.id}
            value={fueltype.id}
            name={fueltype.display_name}
            imageName={fueltype.id}
            imagePath="/images/stationProfile/v2/"
            canToggle
            isActive={!!fuelTypes.find(f => f.id === fueltype.id)}
            handleOnClick={handleOnFuelTypeClick}
          />),
      }))}
      />
    </Modal>
  );
}

FuelTypesEditModal.propTypes = {
  buttonClassName: PropTypes.string,
  fuelTypes: PropTypes.arrayOf(FuelTypePropType).isRequired,
  allFuelTypes: PropTypes.arrayOf(FuelTypePropType).isRequired,
  onSave: PropTypes.func.isRequired,
};

FuelTypesEditModal.defaultProps = {
  buttonClassName: '',
};
